import { slugify, slugifyCollection } from "./slugify"

export const linksBuilder = {
  artworks: (domain, id, str) =>
    domain
      ? `/galleries/${domain}/artworks/${id}-${slugify(str)}`
      : `/artworks/${id}-${slugify(str)}`,
  galleries: (str) => `/galleries/${str}`,
  collections: (id, collection) =>
    `/galleries/${id}/collections/${slugifyCollection(collection)}`,
}
